import axios from 'axios'

export default {
  getCalls (data) {
    return axios.get('/calls?start_date=' + data.startDate + '&end_date=' + data.endDate + '&vendor_id=' + data.vendorId)
  },
}
